<template>
  <div>
    <h1>Naked Scenes in Movies</h1>
    <p style="text-align: center;">Free movies with naked male celebrities</p>
    <p style="text-align: center;">No annoying ads or sudden redirects here!</p>

    <h2 v-if="page > 1">Page: {{page}}</h2>

    <paginate name="pages" :list="videos" :per="30" tag="div" ref="paginator" class="movie-grid">
      <router-link
        v-for="video in paginated('pages')"
        :key="video.id"
        :to="{ name: 'naked-video', params: {id:video.id} }"
        class="grid-box"
      >
        <div class="video-block">
          <img :src="'https:'+video.img" :alt="video.title" class="video-image" />
        </div>
        <div class="movie-text">
          <p>{{video.actor}}</p>
          <p>
            <span>in</span>
          </p>
          <p>"{{video.title}}"</p>
        </div>
      </router-link>
    </paginate>

    <h3 class="paginated-title">Pages</h3>
    <div v-on:click="scrollTop()">
      <paginate-links for="pages" @change="paging"></paginate-links>
    </div>
  </div>
</template>

<script>
import videosJson from "@/az_final_naked.json";
export default {
  metaInfo() {
    return {
      title: "Male Celebrities Naked Videos - Hot Scenes From Movies",
      meta: [
        {
          name: "description",
          content:
            "Free MrMan videos of hot naked male celebrities - Ewan McGregor, Jude Law, Channing Tatum, Leonardo Decaprio, Zac Efron and others - naked in movies."
        }
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.malecinema.com/movies/naked/"
        }
      ]
    };
  },
  data() {
    return {
      paginate: ["pages"],
      videos: [],
      page: 0
    };
  },

  methods: {
    getVideos() {
      const videosList = JSON.parse(JSON.stringify(videosJson));
      //console.log(videosList);
      this.videos = videosList;
      window.scrollTo(0, 0);
    },
    tracking() {
      this.$ga.page("/movies/naked/");
    },
    paging(payload) {
      this.page = payload;
      this.$router.push("/naked/page/" + this.page);
    },
    goToSecondPage() {
      const idNumber = parseInt(this.$route.params.id, 10);
      //console.log(idNumber + " worked");
      if (this.$refs.paginator) {
        this.$refs.paginator.goToPage(idNumber);
      }
    },
    getRoute() {
      if (this.$route.params.id == undefined) {
        this.page = 0;
        if (this.$refs.paginator) {
          this.$refs.paginator.goToPage(1);
        }
      }
    },
    scrollTop() {
      window.scrollTo(0, 0);
    }
  },
  created() {
    this.getVideos();
    this.tracking();
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.goToSecondPage();
    }
  },
  watch: {
    $route() {
      this.tracking();
      this.getRoute();
    }
  }
};
</script>